<label *ngIf="title" attr.for="{{id}}">{{title}}</label>
<input id="{{id}}"
       #typeaheadInput
       [disabled]="isDisabled"
       [ngbTypeahead]="search"
       [value]="inputValue"
       (selectItem)="onItemSelect($event.item)"
       (keyup)="onKeyUp($event)"
       (focusout)="onFocusOut($event); autocompleteInput.dismissPopup();"
       [inputFormatter]="inputFormatter"
       [resultFormatter]="resultFormatter"
       [editable]="editable"
       #autocompleteInput="ngbTypeahead"
       class="form-control"
       attr.aria-label="{{ariaLabel}}"
       aria-expanded="false"
       aria-owns=""
       aria-controls=""
       [ngClass]="{'autocomplete-spinner': loading, 'is-invalid': isInvalid && !autocompleteInput.isPopupOpen()}">
